import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { LoadingSpinner } from './ui/LoadingSpinner'

interface ProtectedRouteProps {
  children: React.ReactNode
  allowMustChangePassword?: boolean
  roles?: Array<'superuser' | 'recruiter'>
}

export function ProtectedRoute({ children, allowMustChangePassword = false, roles }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, recruiter } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner />
      </div>
    )
  }

  if (!isAuthenticated || !recruiter) {
    return <Navigate to="/login" replace />
  }

  if (recruiter.must_change_password && !allowMustChangePassword) {
    return <Navigate to="/set-password" replace />
  }

  if (!recruiter.must_change_password && allowMustChangePassword) {
    return <Navigate to="/dashboard" replace />
  }

  if (roles && !roles.includes(recruiter.role)) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
